<div class="w-full mx-auto rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <h3 class="titre3">{{ 'PARAMETRE_ENTITE.PAGE_EDIT' | translate }}</h3>
  </div>

  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    @if (isLoading) {
      <mat-spinner class="mx-auto" color="accent"></mat-spinner>
    }
    @if (!isLoading && organisation) {
      <div>
        <div class="block text-sm font-medium mb-4">
          <span class="text-lg">{{ 'PARAMETRE_ENTITE.NOM' | translate }} </span> : <span > {{ organisation.nom }}</span>
        </div>
        <div id="nom" class="text-sm font-medium">
          <span class="text-lg">{{ 'PARAMETRE_ENTITE.NOMLEGAL' | translate }}</span>  : <span>{{ organisation.nomLegal }}</span>
        </div>
        <div id="raisonSociale" class="text-sm font-medium mb-4">
          <span class="text-lg">{{ 'PARAMETRE_ENTITE.RAISONSOCIALE' | translate }}</span> : <span>{{ organisation.raisonSociale}}</span>
        </div>
        <div class="mb-4 center">
          <div class="flex justify-center">
            <div class="flex items-center gap-6">
              <div class="flex items-center">
                <input type="radio" id="nomLegal" name="affichageNom"
                  [value]="false"
                  [(ngModel)]="estRaisonSocialeAffiche"
                  [checked]="estRaisonSocialeAffiche == false"
                  (ngModelChange)="onChange()"
                  class="form-radio h-5 w-5 mr-2 focus:outline-none focus:ring-0">
                  <label for="nomLegal" class="text-sm">
                    {{ 'PARAMETRE_ENTITE.NOMLEGAL' | translate }}
                  </label>
                </div>
                <div class="flex items-center">
                  <input type="radio" id="raisonSociale" name="affichageNom"
                    [value]="true"
                    [checked]="estRaisonSocialeAffiche == true"
                    [(ngModel)]="estRaisonSocialeAffiche"
                    (ngModelChange)="onChange()"
                    class="form-radio h-5 w-5 mr-2 focus:outline-none focus:ring-0">
                    <label for="raisonSociale" class="text-sm">
                      {{ 'PARAMETRE_ENTITE.RAISONSOCIALE' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end">
        <button (click)="onCancel()" type="button" class="btn-secondary-novo">
          {{ 'PARAMETRE_ENTITE.ANNULER' | translate }}
        </button>
        <button [disabled]="isSaving || isLoading" (click)="onSave()" type="submit"
          class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
          @if (!isSaving) {
            <span>{{ 'PARAMETRE_ENTITE.SAUVEGARDER' | translate }}</span>
          }
          @if (isSaving) {
            <mat-spinner [diameter]="24" [color]="'accent'"></mat-spinner>
          }
        </button>
      </div>
    </div>
